import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ResearchReportSchema = z.object({
  researchReportId: PrimaryKeySchema,
  title: z.string(),
  content: z.string(),
  createdAt: z.coerce.date(),
});

export type ResearchReport = z.infer<typeof ResearchReportSchema>;

export const ResearchReportsSchema = z.array(ResearchReportSchema);

export type ResearchReports = z.infer<typeof ResearchReportsSchema>;

export const ResearchReportFiltersSchema = z
  .object({
    researchReportIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    createdAtGte: z.coerce.date().optional(),
    createdAtLte: z.coerce.date().optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['createdAt'])));

export type ResearchReportFilters = z.infer<typeof ResearchReportFiltersSchema>;
